import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { Box } from 'components/generic/HomePageComponents'
import {
  MainDiv,
  CenteredRowDiv,
  ImageColumn,
  LinkColumn,
  SmallHeader,
  SmallLink,
  SmallText,
} from './Footer.styles'
import { data } from 'lib/footer'

import CareguideFamily from './CareguideFamily'
import { useContext } from 'react'
import { AppContext } from 'contexts/AppContext'

const Footer = () => {
  const { site } = useContext(AppContext)
  const { header, mainItems, secondaryItems } = data.footer
  const siteName = site?.name
  // TODO: topCitiesData is never actually loaded, so `TopCities` is never rendered.
  // const footerData = site?.navigation?.footer?.navigationItems
  // const topCitiesData = site?.assets?.topCitiesData
  return (
    <>
      {/* <TopCities topCitiesData={topCitiesData} footerData={footerData} /> */}
      <CareguideFamily
        header={header}
        colouredTextItems={mainItems}
        cities={secondaryItems}
        siteName={siteName!}
      />
      <MainDiv role='region' aria-label='Footer'>
        <CenteredRowDiv>
          <ImageColumn
            order={{ _: 6, tablet: 1 }}
            alignItems={{ _: 'center', tablet: 'center', desktop: 'stretch' }}
          >
            <GenericLazyLoadImage
              mb='20px'
              // @ts-ignore invalid types not sure why
              width={{ _: '190px', tablet: '140px' }}
              mt={{ _: '40px', tablet: 0 }}
              src='https://cdn4.careguide.com/assets/branding/tash/logos/logo_careguide-tagline_RGB-c8f9c27c8adf4221e17375cab5e7506e81a053dd8c28b5c65ee6ba3cefa46678.svg'
              role='presentation'
            />
            <Box display='flex' flexDirection={{ _: 'row', tablet: 'column' }}>
              <SmallLink fontSize={{ _: '12px', desktop: '14px' }} mr='8px' href='/privacy'>
                Privacy Policy
              </SmallLink>
              <SmallLink
                fontSize={{ _: '12px', desktop: '14px' }}
                mr='8px'
                href='/terms-of-service'
              >
                Terms of Service
              </SmallLink>
              <SmallLink fontSize={{ _: '12px', desktop: '14px' }} href='/cancellation-policy'>
                Cancellation Policy
              </SmallLink>
            </Box>
            {/* @ts-ignore */}
            <SmallText fontSize={{ _: '12px', desktop: '14px' }} textAlign='center'>
              © 2019 CareGuide Inc.
            </SmallText>
          </ImageColumn>
          <LinkColumn order={2}>
            <SmallHeader mb={{ _: '5px', desktop: '35px' }} mt={{ _: '40px', desktop: 0 }}>
              Contact
            </SmallHeader>
            <SmallText>CareGuide Inc.</SmallText>
            <SmallText>WaterPark Place</SmallText>
            <SmallText>1100 - 20 Bay Street</SmallText>
            <SmallText>Toronto, ON</SmallText>
            <SmallText>M5J 2N8</SmallText>
          </LinkColumn>
          <LinkColumn order={3}>
            <SmallHeader mb={{ _: '5px', desktop: '35px' }} mt={{ _: '40px', desktop: 0 }}>
              Payroll Services
            </SmallHeader>
            <SmallLink href='https://canadiannanny.ca/nanny-tax-payroll'>
              Nanny Tax & Payroll Services
            </SmallLink>
          </LinkColumn>
          <LinkColumn order={4}>
            <SmallHeader mb={{ _: '5px', desktop: '35px' }} mt={{ _: '40px', desktop: 0 }}>
              Need Help?
            </SmallHeader>
            <SmallLink href='https://help.careguide.com/hc/en-us'>Help Center</SmallLink>
            <SmallLink href='/security-info'>Security Info</SmallLink>
          </LinkColumn>
          <LinkColumn order={5}>
            <SmallHeader mb={{ _: '5px', desktop: '35px' }} mt={{ _: '40px', desktop: 0 }}>
              Social
            </SmallHeader>
            <SmallLink href='https://twitter.com/careguide'>Twitter</SmallLink>
            <SmallLink href='https://facebook.com/careguide'>Facebook</SmallLink>
            <SmallLink href='https://www.linkedin.com/company/careguide/'>LinkedIn</SmallLink>
          </LinkColumn>
        </CenteredRowDiv>
      </MainDiv>
    </>
  )
}

export default Footer
